import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'zahlenFormat'
})
export class ZahlenFormatPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

  // rundet auf die gewünschten Nachkommastellen
  round(value: number, precision: number) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }

  // rundet auf 0.05 auf oder ab
  round5(value: number) : number {
    return parseFloat((Math.ceil(value*20 - 0.5)/20).toFixed(2));
  }

}
